import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase 설정 (Firebase Console에서 가져온 설정)
const firebaseConfig = {
  apiKey: "AIzaSyCdkxuB5_IWcbk4Au7NfFAdP1SRB2y-Ixc",
  authDomain: "airjeta-training-system.firebaseapp.com",
  projectId: "airjeta-training-system",
  storageBucket: "airjeta-training-system.firebasestorage.app",
  messagingSenderId: "993315160778",
  appId: "1:993315160778:web:8abacb84f8efe7d6e0ea33"
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Authentication 설정
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Apps Script 웹앱 URL (v4.0 - 2026-01-22 업데이트)
export const API_BASE_URL = "https://script.google.com/macros/s/AKfycbx_OVjOrb_zyKIddcFG3a-t7k2-ioUzZfn0UenmLPB4G5unAfPfJ4ffUQXpHU2PolkSxw/exec";

export default app;
